import React from 'react'
import Navigation from '../Navigation'

export default function Dashboard() {
  return (
    <div>
        <h1>Dasboard</h1>
        <Navigation></Navigation>
    </div>
  )
}
